<template>
  <donut-chart08-template
    :board-ids="[160]"
    :data-type="dataType"
    field-code="facility-public"
    :graph-id="85"
    title="(공중(다중)이용시설) 유해·위험요인 점검(개선) 현황"
    unit="건"/>
</template>
<script>
/* eslint-disable brace-style */
import DonutChart08Template from "@/views/graph/DonutChart08Template.vue";

export default {
  name: 'DonutChart85',
  components: {DonutChart08Template},
  props: {
    dataType: 'detail' | 'field' | 'company' | 'project',
  },
}
</script>

<style scoped>

</style>
